<template>
  <BModal
    :active.sync="show"
    :on-cancel="cancelModal"
    has-modal-card
    trap-focus
    :can-cancel="false"
    :destroy-on-hide="false"
    aria-role="dialog"
    aria-modal
  >
    <div class="modal-card modal-confirm" style="width: auto">
      <section class="modal-card-body">
        <div class="close-button" @click="cancelModal">
          Cerrar <img src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_close.png" alt="close" width="12" />
        </div>
        <section class="modal-comparative-previous-tournaments">
          <HeaderComponent
            title="Comparativo vs torneos anteriores"
            titlemovil="Comparativo vs torneos <br/> anteriores"
          />
          <div class="modal-comparative-previous-tournaments__cont-table"><TableComparativePreviousTournaments /></div>
        </section>
      </section>
    </div>
  </BModal>
</template>

<script>
export default {
  name: 'ModalComparativePreviousTournaments',
  components: {
    HeaderComponent: () => import('@/components/ActiveTime/Elements/HeaderComponent'),
    TableComparativePreviousTournaments: () =>
      import('@/components/ActiveTime/Elements/TableComparativePreviousTournaments'),
  },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
  },
  computed: {},
  data() {
    return {};
  },
  methods: {
    cancelModal() {
      this.$emit('onCancel');
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.modal-comparative-previous-tournaments {
  width: 768px;
  height: 289px;
  @media screen and (max-width: 768px) {
    width: 100%;
  }
  &__cont-table {
    width: 100%;
    height: 231px;
    border-radius: 8px;
    border: solid 1px #132739;
    margin-top: 10px;
  }
}
.close-button {
  display: inline-flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  cursor: pointer;
  position: absolute;
  width: 87px;
  height: 20px;
  border-radius: 20px;
  background-color: #132839;
  right: 7px;
  top: 10px;
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.47;
  letter-spacing: -0.15px;
  text-align: center;
  color: #fff;
  font-family: 'Roboto-Regular';
  img {
    margin-left: 5px;
    margin-top: -2px;
  }
  &:hover {
    background: rgb(71, 71, 71);
    cursor: pointer;
  }
}
.modal-card-body {
  padding: 20px 20px 0px 20px !important;
  @media screen and (max-width: 400px) {
    padding: 20px 5px 0px 5px !important;
  }
}
.modal-confirm {
  padding: 18px 0px 25px;
  border-radius: 17px;
  box-shadow: 0 17px 32px 0 rgba(0, 0, 0, 0.5);
  background-color: #ffffff;
}
</style>
